import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation myAccountSet(
    $id: Int!,
    $fiscalYearStart: Date,
    $fiscalYearEnd: Date,
    ) {
    myAccountSet(input: {
      id: $id,
      fiscalYearStart: $fiscalYearStart,
      fiscalYearEnd: $fiscalYearEnd,
    }) {
      error
    }
  }
`;

export function useUpdateFiscalYear() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
